// ponytail: in-flight GET coalescing. When several components mount together and
// each fires the same read request, they share one network call instead of N.
// The entry is evicted as soon as the request settles, so a later refetch always
// hits the network — no stale data is ever served, and no invalidation-on-mutation
// story is needed. This only merges calls that overlap in time (the React mount
// burst); calls fired seconds apart are left independent on purpose.
const inFlight = new Map();

export const dedupeRequest = (key, fn) => {
  if (inFlight.has(key)) return inFlight.get(key);
  const promise = Promise.resolve()
    .then(fn)
    .finally(() => inFlight.delete(key));
  inFlight.set(key, promise);
  return promise;
};
